import { CHECKLIST_STATE } from "../../../other/constants/OtherKeys.jsx";

export const HasChecklistMixin = (target) => class extends target {
  static get fields() {
    return [
      { name: "_checklistStatus", dataSource: "checklist_status", type: "number" },
      { name: "_checklistCount", dataSource: "checklist_count", type: "number" }
    ];
  }

  get checklistStatus() {
    // Prefer entity payload annotations; checklist Bryntum store is no longer loaded.
    const annotated = this.get("_checklistStatus");
    if (annotated != null) return annotated;
    return CHECKLIST_STATE.NO_CHECKLIST;
  }

  get checklistCount() {
    const annotated = this.get("_checklistCount");
    if (annotated != null) return annotated;
    return 0;
  }
};
